import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DepartmentPage from './pages/DepartmentPage';
import DepartmentDetailPage from './pages/DepartmentDetailPage';
import DepartmentDetailPageNew from './pages/DepartmentDetailPageNew';
import CreateProfilePage from './pages/CreateProfilePage';
import PostProjectPage from './pages/PostProjectPage';
import ContributeVendorPage from './pages/ContributeVendorPage';
import AboutPage from './pages/AboutPage';
import HowItWorksPage from './pages/HowItWorksPage';
import DepartmentsListPage from './pages/DepartmentsListPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import AuthPage from './pages/AuthPage';
import DiscoverProjectsPage from './pages/DiscoverProjectsPage';
import JobListingsPage from './pages/JobListingsPage';
import AdminDashboard from './pages/AdminDashboard';
import UserProfileDetailPage from './pages/UserProfileDetailPage';
import VendorDetailPage from './pages/VendorDetailPage';
import AuthCallback from './components/AuthCallback';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Router component to handle auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id synchronously during render (not in useEffect)
  // This prevents race conditions with AuthProvider
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/departments/:state/:city" element={<DepartmentPage />} />
      <Route path="/departments/:state/:city/:department" element={<DepartmentDetailPage />} />
      <Route path="/department/:departmentName" element={<DepartmentDetailPageNew />} />
      <Route path="/create-profile" element={<CreateProfilePage />} />
      <Route path="/post-project" element={<PostProjectPage />} />
      <Route path="/contribute" element={<ContributeVendorPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/departments" element={<DepartmentsListPage />} />
      <Route path="/success-stories" element={<SuccessStoriesPage />} />
      <Route path="/help" element={<HelpCenterPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/signup" element={<AuthPage />} />
      <Route path="/signin" element={<AuthPage />} />
      <Route path="/discover" element={<DiscoverProjectsPage />} />
      <Route path="/discover/jobs" element={<JobListingsPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/profile/:user_id" element={<UserProfileDetailPage />} />
      <Route path="/vendor/:vendor_id" element={<VendorDetailPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;